export interface RuntimeConfig {
  apiUrl?: string;
  wsUrl?: string;
  basePath?: string;
  embed?: boolean;
  embedOrigins?: string[];
  appName?: string;
}

declare global {
  interface Window {
    __KORIN_CONFIG__?: RuntimeConfig;
  }
}

const runtime: RuntimeConfig = (typeof window !== "undefined" && window.__KORIN_CONFIG__) || {};

export const API_URL = (runtime.apiUrl ?? import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");
export const BASE_PATH = runtime.basePath ?? import.meta.env.BASE_URL ?? "/";
export const APP_NAME = runtime.appName ?? "Korin Studio";
export const EMBED_MODE =
  runtime.embed === true ||
  (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("embed") === "1");
export const EMBED_ORIGINS: string[] =
  runtime.embedOrigins ??
  (import.meta.env.VITE_EMBED_ORIGINS
    ? String(import.meta.env.VITE_EMBED_ORIGINS).split(",").map((origin) => origin.trim()).filter(Boolean)
    : []);

export function apiUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return `${API_URL}${path}`;
}

export function mediaUrl(path?: string | null): string | undefined {
  if (!path) return undefined;
  if (/^https?:\/\//.test(path) || path.startsWith("data:")) return path;
  return `${API_URL}${path}`;
}

export function collabUrl(): string {
  if (runtime.wsUrl) return runtime.wsUrl.replace(/\/$/, "");
  const base = new URL(API_URL || window.location.origin, window.location.origin);
  const protocol = base.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${base.host}/collab`;
}

export function routerBasename(): string | undefined {
  const path = BASE_PATH.replace(/\/$/, "");
  return path ? path : undefined;
}

export function withBase(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  const base = BASE_PATH.replace(/\/$/, "");
  return `${window.location.origin}${base}${path.startsWith("/") ? path : `/${path}`}`;
}

export function postToHost(type: string, payload: Record<string, unknown> = {}): void {
  if (typeof window === "undefined" || window.parent === window) return;
  window.parent.postMessage(
    { source: "korin-studio", type, ...payload },
    EMBED_ORIGINS[0] ?? "*",
  );
}

export const IS_DEV = import.meta.env.DEV;
